module.exports = __webpack_public_path__ + "img/gb9118_1_h.prt.8600b3ed.jpg";